export default "__VITE_ASSET__DjKBnn6Z__"